import ChooseDialog from './src/index.vue'

ChooseDialog.install = (Vue) => {
  Vue.component(ChooseDialog.name, ChooseDialog)
}

export default ChooseDialog
